import { Component, OnInit } from '@angular/core';
import { AuditService } from '../../../services/audit.service';
import {SearchService} from '../../../services/search.service';

@Component({
  selector: 'app-audit-events',
  templateUrl: './audit-events.component.html',
  styleUrls: ['./audit-events.component.css']
})
export class AuditEventsComponent implements OnInit {

  displayedColumns: string[] = [];
  dataSource = [];

  eventsHeading: any;
  eventsData: any;

  left: any;
  top: any;
  tooltipValue: any;
  resourceTip = false;

  thisItemData: any;
  
  constructor(private searchService: SearchService, private auditService: AuditService) { }

  ngOnInit() {
    /**/
    if (this.searchService.selectedItemIndex !== null) {
      this.thisItemData = this.auditService.itemDataSource[this.searchService.selectedIndex].filteredData[this.searchService.selectedItemIndex];
      if (!this.auditService.itemDataSource[this.searchService.selectedIndex].filteredData[this.searchService.selectedItemIndex].eventDisplayColumns) {
        this.getEventsHeading();
        this.getEvents();
      }
    }
  }

  showResourceTip (e: any, thisVal: any, showHideTooltip: boolean) {
    this.left = e.clientX - 10 + "px";
    this.top = e.clientY - 80 + "px";
    this.tooltipValue = thisVal;
    this.resourceTip = showHideTooltip;
  }

  sortTable(event: any, filedName: any) {
    if (!this.thisItemData.params) {
      this.thisItemData.params = {};
    }
    if (this.thisItemData.params.sortby === filedName) {
      if (this.thisItemData.params.order === 'asc') {
        this.thisItemData.params.order = 'dsc';
      } else if (this.thisItemData.params.order === 'dsc') {
        this.thisItemData.params.order = '';
      } else {
        this.thisItemData.params.order = 'asc';
      }
    } else {
      this.thisItemData.params.order = 'asc';
    }
    
    this.thisItemData.params.sortby = filedName;
    this.getEvents();
  }

  filterAuditEvents(event: any, fieldName: any) {
    if (!this.thisItemData.params) {
      this.thisItemData.params = {};
    }
    if (event.target.value) {
      this.thisItemData.params[fieldName] = event.target.value;
    } else {
      delete this.thisItemData.params[fieldName];
    }
    this.getEvents();
  }

  getEventsHeading = (): void => {
    this.thisItemData.eventDisplayColumns = [];
    this
      .auditService
      .getAuditEventHeading()
      .subscribe(data => {
        this.eventsHeading = data;
        for (let [key, value] of Object.entries(this.eventsHeading.data.auditEventFilters)) {
          if(this.eventsHeading.data.auditEventFilters[key].type.toLowerCase() == "object" && this.eventsHeading.data.auditEventFilters[key].keys) {
            for (let [itemKey, itemvalue] of Object.entries(this.eventsHeading.data.auditEventFilters[key].keys)) {
              this.thisItemData.eventDisplayColumns.push(this.eventsHeading.data.auditEventFilters[key].keys[itemKey].name)
            }
          } else {
            this.thisItemData.eventDisplayColumns.push(this.eventsHeading.data.auditEventFilters[key].name)
          }
        }
    });
  };

  /**
   * Funtion to seperate the all the Key and value in a JSON
   * This will pick all the heading from the passed JSON object.
   * @param thisVaalue - Shoud be a JSON
   * Check the typeof the value and if it is an object, 
   * then make it as an recursive function, by passing the object again to the same function
   */
  parseValues = (thisValue: any): void => {
    Object.keys(thisValue).forEach(key => {
      if (typeof thisValue[key] === 'object' && thisValue[key]) {
        if(thisValue['name'] !== 'Resources') {
          this.parseValues(thisValue[key]);
        }
      } else if(key === 'name' && thisValue[key] !== 'itemState') {
        this.thisItemData.eventDisplayColumns.push(thisValue[key]);
      }
    })
  }

  getEvents = (): void => {
    this
      .auditService
      .getAuditEvents()
      .subscribe(data => {
        this.eventsData = data;
        this.thisItemData.eventDataSource = this.eventsData.data.auditEvents;
      });
  };
}
